import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _get from "@babel/runtime/helpers/get";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
var _excluded = ["infoId", "uid"];
var _class, _class2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { lego } from '@zz-common/lego';
import { messager, WaitJsLoaded, getCookie, searchM, getDetailUrl, urlFormatter, getPPU, getDomain, getUrlParams, creatIframe, domainReplacement, request, loadJS, isZZUrl, isZZSellerUrl, isCheckUrl, getDomainFromURL, setCookie, isHTTPUrl, isZZ, isAndroid, QQ_MAP_KEY, getPoiMarkerUrl, getVisibilityChangeSupported, guid, addQuery, getZZVersion, compareVersion } from "../../core/utils";
import { beforeLogin } from "./LoginAdapter";
var is58Domain = /58\.com/.test(location.href);
var API_DOMAIN = is58Domain ? 'zhuan.58.com' : 'app.zhuanzhuan.com';
var canRunnablePlatformNameList = ['zz', 'zzupdoor', 'zzstore', 'qcqualityinspect', 'wmspda', 'QualityInspect', 'zzluxury', 'zzqcidentity', 'zztong', 'storevaluation'];
var BaseAdapter = (_class = (_class2 = /*#__PURE__*/function (_WaitJsLoaded) {
  _inherits(BaseAdapter, _WaitJsLoaded);
  var _super = _createSuper(BaseAdapter);
  function BaseAdapter() {
    var _this;
    _classCallCheck(this, BaseAdapter);
    for (var _len = arguments.length, props = new Array(_len), _key = 0; _key < _len; _key++) {
      props[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(props));
    // 端内不用走 白名单检验  减少请求
    var isZZThan9_12 = isZZ && compareVersion(getZZVersion(), '9.12.0') >= 0;
    _this.skipCheckWhiteList = isZZThan9_12;
    _this.urlDomainWhiteList = ['.58.com', '.zhuanzhuan.com', '.zhuanstatic.com'];
    _this.loadWhiteListSuccess = null;
    _this.loadWhiteListFail = null;
    _this.hasLoadedWhiteList = new Promise(function (resolve, reject) {
      _this.loadWhiteListSuccess = resolve;
      _this.loadWhiteListFail = reject;
    });

    // 请求白名单，延迟300ms，避免影响业务性能
    !_this.skipCheckWhiteList && setTimeout(function () {
      _this.fetchUrlDomainWhiteList();
    }, 300);
    return _this;
  }
  _createClass(BaseAdapter, [{
    key: "_invoke",
    value: function _invoke(key, argv) {
      var _this2 = this;
      this._invokeCB(function () {
        if (_this2[key]) {
          messager.$emit.apply(messager, [key].concat(_toConsumableArray(argv)));
          _get(_getPrototypeOf(BaseAdapter.prototype), "_invoke", _this2).call(_this2, key, argv);
        } else if (!_this2.__sdk || !_this2.__sdk[key]) {
          // 新版sdk中使用run运行方法
          if (_this2.native.currentPlatform.name == 'zlj' && _this2.native.currentPlatform.isNewWebview || canRunnablePlatformNameList.includes(_this2.native.currentPlatform.name)) {
            var _this2$__sdk;
            (_this2$__sdk = _this2.__sdk).run.apply(_this2$__sdk, [key].concat(_toConsumableArray(argv)));
          } else {
            console.warn("\u8BE5\u7AEF\u672A\u5B9E\u73B0".concat(key, "\u65B9\u6CD5\uFF0C\u8BF7\u786E\u8BA4"));
          }
        } else {
          _this2.__sdk[key].apply(_this2.__sdk, argv);
        }
      });
    }
  }, {
    key: "fetchUrlDomainWhiteList",
    value: function fetchUrlDomainWhiteList() {
      var _this$native;
      var self = this;
      var cbName = "fetchUrlDomainWhiteList".concat(guid());
      window[cbName] = function (data) {
        var _ref = data.respData || {},
          urlDomainWhiteList = _ref.urlDomainWhiteList;
        if (urlDomainWhiteList instanceof Array) {
          self.urlDomainWhiteList = urlDomainWhiteList;
          self.loadWhiteListSuccess();
        } else {
          self.loadWhiteListFail();
        }
      };
      var fetchUrl = '';
      if (is58Domain) {
        fetchUrl = "https://zhuan.58.com/zz/transfer/getmhostlist?callback=".concat(cbName);
      } else {
        // 只返回少量公开白名单域名
        fetchUrl = "https://app.zhuanzhuan.com/zz/transfer/getmhostlist?callback=".concat(cbName, "&mixValidate=1");
      }
      if ((_this$native = this.native) !== null && _this$native !== void 0 && (_this$native = _this$native.config) !== null && _this$native !== void 0 && _this$native.pt) {
        var _this$native2;
        fetchUrl += "&pt=".concat((_this$native2 = this.native) === null || _this$native2 === void 0 || (_this$native2 = _this$native2.config) === null || _this$native2 === void 0 ? void 0 : _this$native2.pt);
      }
      loadJS(fetchUrl, function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "checkWhiteUrlByServer",
    value: function () {
      var _checkWhiteUrlByServer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(targetUrl) {
        var _this3 = this;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", new Promise(function (res) {
                var _this3$native;
                var cbName = "checkWhiteUrlByServer".concat(guid());
                window[cbName] = function (data) {
                  var _data$respData;
                  console.log('checkWhiteUrlByServer', data.respData);
                  if ((data === null || data === void 0 || (_data$respData = data.respData) === null || _data$respData === void 0 ? void 0 : _data$respData.result) === '1') {
                    res(true);
                  } else {
                    res(false);
                  }
                };
                var fetchUrl = "https://app.zhuanzhuan.com/zz/v2/zzlogic/validateloadurl?loadUrl=".concat(encodeURIComponent(targetUrl), "&callback=").concat(cbName);
                if ((_this3$native = _this3.native) !== null && _this3$native !== void 0 && (_this3$native = _this3$native.config) !== null && _this3$native !== void 0 && _this3$native.pt) {
                  var _this3$native2;
                  fetchUrl += "&pt=".concat((_this3$native2 = _this3.native) === null || _this3$native2 === void 0 || (_this3$native2 = _this3$native2.config) === null || _this3$native2 === void 0 ? void 0 : _this3$native2.pt);
                }
                loadJS(fetchUrl, function () {
                  return window[cbName] = void 0;
                });
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function checkWhiteUrlByServer(_x) {
        return _checkWhiteUrlByServer.apply(this, arguments);
      }
      return checkWhiteUrlByServer;
    }()
  }, {
    key: "checkInWhiteList",
    value: function () {
      var _checkInWhiteList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(targetUrl) {
        var canSkip, urlObj, searchParams, searchDomain, searchObj, checkedList, whiteDomain, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!this.skipCheckWhiteList) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", true);
            case 2:
              _context2.prev = 2;
              _context2.next = 5;
              return this.hasLoadedWhiteList;
            case 5:
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](2);
              console.error(_context2.t0);
            case 10:
              // 判断域名是否在白名单之内
              canSkip = false;
              urlObj = {};
              try {
                urlObj = new URL(targetUrl);
              } catch (error) {
                urlObj.host = getDomainFromURL(targetUrl);
              }
              searchParams = urlObj.search || ''; // decode 所有的转义字符
              while (searchParams !== decodeURIComponent(searchParams)) {
                searchParams = decodeURIComponent(searchParams);
              }
              searchDomain = [];
              searchObj = {};
              searchParams.split('?').forEach(function (item) {
                if (item) {
                  // ??是为了兼容getUrlParams方法
                  searchObj = _objectSpread(_objectSpread({}, searchObj), getUrlParams("??".concat(item)));
                }
              });
              Object.keys(searchObj).forEach(function (key) {
                var host = '';
                try {
                  var val = searchObj[key];
                  if (/^http(s)?:\/\//.test(val)) {
                    host = new URL(val).host;
                  }
                } catch (error) {
                  host = '';
                }
                host && searchDomain.push(host);
              });
              searchDomain.push(urlObj.host);
              checkedList = []; // 1. 先在白名单校验 (后端暴露出来的白名单为存量白名单)
              _context2.prev = 21;
              whiteDomain = this.urlDomainWhiteList;
              searchDomain.forEach(function (domain) {
                whiteDomain.forEach(function (wDomain) {
                  if (domain.indexOf(wDomain) > -1) {
                    checkedList.push(domain);
                  }
                });
              });
              if (!(checkedList.length < searchDomain.length)) {
                _context2.next = 31;
                break;
              }
              _context2.next = 27;
              return this.checkWhiteUrlByServer(targetUrl);
            case 27:
              res = _context2.sent;
              if (res === true) {
                canSkip = true;
              }
              _context2.next = 32;
              break;
            case 31:
              canSkip = true;
            case 32:
              _context2.next = 36;
              break;
            case 34:
              _context2.prev = 34;
              _context2.t1 = _context2["catch"](21);
            case 36:
              return _context2.abrupt("return", canSkip);
            case 37:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 7], [21, 34]]);
      }));
      function checkInWhiteList(_x2) {
        return _checkInWhiteList.apply(this, arguments);
      }
      return checkInWhiteList;
    }()
  }, {
    key: "skipToUrl",
    value: function () {
      var _skipToUrl = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(obj) {
        var targetUrl, _obj$extra, extra, needClose, canSkip, redirectMode, isZZAndroid;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              targetUrl = obj.targetUrl, _obj$extra = obj.extra, extra = _obj$extra === void 0 ? {} : _obj$extra, needClose = obj.needClose;
              targetUrl = addQuery(targetUrl, extra);
              targetUrl = domainReplacement(targetUrl);
              if (!(isZZUrl(targetUrl) || isZZSellerUrl(targetUrl) || isCheckUrl(targetUrl))) {
                _context3.next = 6;
                break;
              }
              this.enterUnifiedUrl({
                unifiedUrl: targetUrl
              });
              return _context3.abrupt("return");
            case 6:
              _context3.next = 8;
              return this.checkInWhiteList(targetUrl);
            case 8:
              canSkip = _context3.sent;
              redirectMode = window.location.href.indexOf('/Mzhuanzhuan/zhuanzhuan/zzactivity/magic/') > -1 ? top.location : window.location;
              if (canSkip) {
                // 需要关闭当前则用replace
                if (needClose == 1) {
                  isZZAndroid = isZZ && isAndroid();
                  redirectMode.replace(urlFormatter(targetUrl, isZZAndroid));
                } else {
                  redirectMode.href = urlFormatter(targetUrl);
                }
              } else {
                alert("\u8DF3\u8F6C\u7F51\u5740\u4E2D\u542B\u6709\u4E0D\u5B89\u5168\u7684\u57DF\u540D\uFF0C\u8BBF\u95EE\u8BE5\u7F51\u5740\u53EF\u80FD\u4F1A\u7ED9\u60A8\u9020\u6210\u8D22\u4EA7\u635F\u5931\u6216\u9690\u79C1\u6CC4\u9732\uFF0C\u672C\u6B21\u8DF3\u8F6C\u5931\u8D25\n\n\u76EE\u6807\u7F51\u5740\uFF1A".concat(targetUrl));
                console.log('跳转失败，当前域名不在白名单中');
              }
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function skipToUrl(_x3) {
        return _skipToUrl.apply(this, arguments);
      }
      return skipToUrl;
    }()
  }, {
    key: "login",
    value: function login(callback) {
      var targetUrl;
      var isCheck;
      var isZlj;
      var isHunter;
      var needReplaceLocation;
      var headTip;
      var skipByLocation;
      if (_typeof(callback) == 'object') {
        targetUrl = callback.targetUrl;
        isCheck = callback.isCheck;
        isZlj = callback.isZlj;
        isHunter = callback.isHunter;
        headTip = callback.headTip;
        needReplaceLocation = callback.needReplaceLocation;
        skipByLocation = callback.skipByLocation;
        callback = callback.callback;
      }
      targetUrl = targetUrl || location.href;
      var domain = getDomain(targetUrl);
      var checkURL = "".concat(domain, "/g/g-loginsms/index.html?callbackUrl=").concat(encodeURIComponent(targetUrl), "#/login");
      var zljURL = "https://jqh5.zhaoliangji.com/#/login?redirect=".concat(encodeURIComponent(targetUrl));
      if (isHunter) {
        domain = 'https://m.caihuoxia.com';
      }
      var commonURL = "".concat(domain, "/common/loginsms/index.html?headTip=").concat(encodeURIComponent(headTip || ''), "&callbackUrl=").concat(encodeURIComponent(targetUrl), "#/login");
      if (skipByLocation) {
        commonURL = "".concat(domain, "/common/loginsms/index.html?headTip=").concat(encodeURIComponent(headTip || ''), "&skipByLocation=").concat(skipByLocation, "&callbackUrl=").concat(encodeURIComponent(targetUrl), "#/login");
      }
      var redirectMethod = needReplaceLocation ? 'replace' : 'assign';
      if (!this.isLogin()) {
        // 判断url中是否存在token或PPU，且token的值为PPU
        // 如果存在，则把PPU解析好，放入cookie中，并且执行登录成功的回调
        // 如果不存在，则跳转登录页面
        var ppu = getUrlParams(undefined, true).token || getUrlParams().PPU;
        ppu = decodeURIComponent(ppu);
        if (isCheck) {
          window.location[redirectMethod](checkURL);
        } else if (ppu) {
          // 通过判断token中是否含有UID=字段，来判断token是否为PPU
          if (ppu && ppu.indexOf('UID=') > -1) {
            if (!/^['|"]/.test(ppu)) {
              ppu = "\"".concat(ppu, "\"");
            }
            setCookie('PPU', ppu);
            setCookie('ZZU', ppu);
            callback({
              code: '0'
            });
          } else if (isZlj) {
            window.location[redirectMethod](zljURL);
          } else {
            window.location[redirectMethod](commonURL);
          }
        } else {
          window.location[redirectMethod](commonURL);
        }
      } else if (callback) callback({
        code: '0'
      });
    }
  }, {
    key: "close",
    value: function close() {
      window.history.go(-1);
    }
  }, {
    key: "enterUnifiedUrl",
    value: function enterUnifiedUrl() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      var url = args[0].unifiedUrl;
      if (isHTTPUrl(url)) {
        this.skipToUrl({
          targetUrl: url
        });
        return;
      }
      window.location.href = urlFormatter(url);
    }
  }, {
    key: "setTitle",
    value: function setTitle(obj) {
      var title = obj.title;
      document.title = title;
    }
  }, {
    key: "asyncIn",
    value: function asyncIn(keyword, cbsucss, cbfail) {
      this.native.in(keyword) ? cbsucss && cbsucss() : cbfail && cbfail();
    }
  }, {
    key: "getFormatPPU",
    value: function getFormatPPU() {
      return getPPU() || '';
    }
  }, {
    key: "getUid",
    value: function getUid() {
      var uid = getPPU().UID || getCookie('uid');
      return /\d{6,24}/.test(uid) ? uid : '';
    }
  }, {
    key: "skipToSearchResult",
    value: function skipToSearchResult(obj) {
      var keyWord = obj.keyWord,
        title = obj.title;
      var history = localStorage.getItem('searchHistory') || '';
      var encodeKeyWord = encodeURIComponent(keyWord);
      history = [encodeKeyWord].concat(_toConsumableArray(history.split(',').filter(function (v) {
        return v;
      }))).reduce(function (arr, key) {
        if (arr.indexOf(key) < 0) arr.push(key);
        return arr;
      }, []).slice(0, 10).join(',');
      localStorage.setItem('searchHistory', history);
      this.skipToUrl({
        targetUrl: searchM(keyWord),
        newPageTitle: title
      });
    }
  }, {
    key: "isLoginAsync",
    value: function isLoginAsync(_ref2) {
      var source = _ref2.source,
        callback = _ref2.callback;
      try {
        var cbName = "isLoginAsync".concat(guid());
        var isNoSource = typeof source === 'undefined' || source === '';
        window[cbName] = function (data) {
          var respCode = data.respCode,
            respData = data.respData;
          callback && callback(+respCode === 0 ? isNoSource ? true : respData.result === 'true' : false);
        };
        var url = '';
        if (isNoSource) {
          // 没有传source的情况，使用接口判断
          url = "https://app.zhuanzhuan.com/zz/transfer/verifyapplogin?callback=".concat(cbName);
        } else {
          // source 小程序判断是否登录，source是传的微信主体，在微信里面生成
          url = "https://".concat(API_DOMAIN, "/zz/transfer/hasauthorized?source=").concat(source, "&callback=").concat(cbName);
        }
        loadJS(url, function () {
          return window[cbName] = void 0;
        });
      } catch (error) {
        // 如果接口检查报错使用同步的方式
        callback && callback(this.isLogin());
      }
    }
  }, {
    key: "isLogin",
    value: function isLogin() {
      // const isZLJNew = /zhaoliangji-v2/ig.test(navigator.userAgent)

      // if (isZLJNew) {
      //   // 找靓机新的webview里面，通过sdk的方法判断是否登录
      //   return false;
      // }

      // console.log('如果是找靓机App，也可以使用checkLogin来判断是否登录')
      if (this.native.currentPlatform.name === 'app58') {
        return !!(getCookie('PPU') && getCookie('ZZU'));
      }
      // 小程序中判断cookies是否含有PPU并且是否过期
      if (this.native.currentPlatform.name === 'miniprogram') {
        if (!getCookie('PPU') || getCookie('PPU').replace(/"/g, '') && !this.getFormatPPU().ET || getCookie('PPU').replace(/"/g, '') && this.getFormatPPU().ET && !window.isNaN(parseInt(this.getFormatPPU().ET)) && parseInt(this.getFormatPPU().ET) < new Date().getTime()) {
          // 如果过期从url读取ppu
          var _params = getUrlParams();
          var ppu = decodeURIComponent(_params.PPU || '');
          if (!!ppu && !/^['|"]/.test(ppu)) {
            ppu = "\"".concat(ppu, "\"");
            setCookie('PPU', ppu);
            return true;
          }
          return false;
        }
        return true;
      }
      return !!getCookie('PPU').replace(/"/g, '') && this.getFormatPPU().ET && !window.isNaN(parseInt(this.getFormatPPU().ET)) && parseInt(this.getFormatPPU().ET) >= new Date().getTime();
    }
  }, {
    key: "bindPhone",
    value: function bindPhone() {
      var targetUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.href;
      var replace = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var domain = getDomain(targetUrl);
      var url = "".concat(domain, "/common/loginsms/index.html?updateMobile=true&forceBind=true&callbackUrl=").concat(encodeURIComponent(targetUrl), "#/login");
      if (replace) {
        location.replace(url);
      } else {
        location.href = url;
      }
    }
  }, {
    key: "getUserInfo",
    value: function getUserInfo(callback) {
      var cbName = "getUserInfoCb".concat(guid());
      window[cbName] = function (data) {
        if (typeof callback != 'function') {
          callback = callback.success;
        }
        callback && callback(data);
      };
      loadJS("https://".concat(API_DOMAIN, "/zzopen/userapi/myinfo?callback=").concat(cbName), function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "isBindPhone",
    value: function isBindPhone(callback) {
      request({
        url: "https://".concat(API_DOMAIN, "/zz/transfer/isUserBindMobile"),
        timeout: 1000
      }).then(function (data) {
        var respCode = data.respCode,
          respData = data.respData;
        callback && callback(+respCode === 0 ? respData.isBindMobile : false);
      });
    }
  }, {
    key: "skipToDetail",
    value: function skipToDetail(obj) {
      var _this4 = this;
      var infoId = obj.infoId,
        _obj$metric = obj.metric,
        metric = _obj$metric === void 0 ? '' : _obj$metric,
        isTrade = obj.isTrade,
        _obj$from = obj.from,
        from = _obj$from === void 0 ? '' : _obj$from,
        _obj$isZlj = obj.isZlj,
        isZlj = _obj$isZlj === void 0 ? false : _obj$isZlj,
        _obj$extraParam = obj.extraParam,
        extraParam = _obj$extraParam === void 0 ? {} : _obj$extraParam,
        _obj$extra2 = obj.extra,
        extra = _obj$extra2 === void 0 ? {} : _obj$extra2,
        _obj$needClose = obj.needClose,
        needClose = _obj$needClose === void 0 ? '0' : _obj$needClose;
      var extParam = '';
      try {
        extParam = encodeURIComponent(JSON.stringify(extraParam));
      } catch (error) {
        console.error('[adapter - skipToDetail] extraParam 参数解析异常');
      }
      var cbName = "getCoodsDetailDataCb".concat(guid());
      obj.$customUrl = "".concat(getDomain(), "/platform/zzmshare/index.html?isTrade=").concat(isTrade ? 1 : 0, "&metric=").concat(metric, "&zzfrom=").concat(metric, "#/detail/").concat(infoId);
      var defaultUrl = getDetailUrl(obj);
      var callbackUrl = "https://app.zhuanzhuan.com/zz/transfer/getgoodsdetaildataexclusive?infoId=".concat(infoId, "&from=").concat(from, "&callback=").concat(cbName, "&metric=").concat(metric, "&extraparam=").concat(extParam);
      if (isZlj) {
        callbackUrl = "https://app.zhuanzhuan.com/zzopen/zljmall/getWebUrl?infoId=".concat(infoId, "&callback=").concat(cbName, "&metric=").concat(metric);
      }
      window[cbName] = function (data) {
        var respCode = data.respCode,
          respData = data.respData;
        if (+respCode === 0) {
          defaultUrl = respData.webUrl || defaultUrl;
        }
        _this4.agentSkipToDetail(obj, function () {
          _this4.skipToUrl({
            targetUrl: defaultUrl,
            extra: extra,
            needClose: needClose
          });
        });
      };
      loadJS(callbackUrl, function () {
        return window[cbName] = void 0;
      });
    }
  }, {
    key: "agentSkipToDetail",
    value: function agentSkipToDetail(obj, cb) {
      var metric = obj.metric,
        businessTicket = obj.businessTicket;
      if (businessTicket && businessTicket.adTicket) {
        var ticketData = _objectSpread({
          metric: metric
        }, businessTicket);
        return this.getBusinessTicket(ticketData, function () {
          cb();
        });
      }
      return cb();
    }
  }, {
    key: "enterProfile",
    value: function enterProfile(obj) {
      var userId = obj.userId;
      var targetUrl = "".concat(getDomain(), "/platform/zzmshare/index.html#/personal/").concat(userId);
      this.skipToUrl({
        targetUrl: targetUrl
      });
    }
  }, {
    key: "getMapLocation",
    value: function getMapLocation() {
      var _window$nativeAdapter;
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      // 兼容旧版 只传入callback
      if (typeof obj === 'function') {
        callback = obj;
      }
      // 腾讯地图文档 https://lbs.qq.com/tool/component-picker.html
      var iframeId = 'mapPage';
      var mapPage = document.getElementById(iframeId);
      var _ref3 = obj,
        lon = _ref3.lon,
        lat = _ref3.lat,
        coordtype = _ref3.coordtype;
      // coord用英文逗号分隔，纬度(latitude)在前，经度(longitude)在后  coord=40.022964,116.319723
      var coord = '';
      if (lon && lat) {
        coord = "&coord=".concat(lat, ",").concat(lon, "&coordtype=").concat(coordtype || 5);
      }
      var KEY = ((_window$nativeAdapter = window.nativeAdapterConfig) === null || _window$nativeAdapter === void 0 ? void 0 : _window$nativeAdapter.qqMapKey) || QQ_MAP_KEY;
      var mapUrl = "https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=".concat(KEY, "&referer=zzapp").concat(coord);
      if (!mapPage) creatIframe(mapUrl, iframeId);else {
        mapPage.style.display = 'block';
      }
      var listenserFun = function listenserFun(event) {
        // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
        var loc = event.data;
        if (loc && loc.module === 'locationPicker' && loc.poiaddress) {
          // 防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
          try {
            var map = document.getElementById('mapPage');
            setTimeout(function () {
              map.style.display = 'none';
              window.removeEventListener('message', listenserFun);
              typeof callback === 'function' && callback(loc);
            }, 300);
          } catch (error) {}
        }
      };
      window.addEventListener('message', listenserFun, false);
    }
  }, {
    key: "getMarkLocation",
    value: function getMarkLocation(params) {
      var href = getPoiMarkerUrl(params);
      location.href = href;
    }
  }, {
    key: "getBusinessTicket",
    value: function getBusinessTicket(obj, cb) {
      var legoParams = _objectSpread({
        token: getCookie('tk'),
        brand: getCookie('brand'),
        version: getCookie('v'),
        ua: window.navigator.userAgent
      }, obj);
      lego.send({
        pagetype: 'AD_YOUPINLIST',
        actiontype: 'AD_CLICK_ALL',
        backup: _objectSpread({
          status: 0
        }, legoParams)
      });
      request({
        url: 'https://jump.zhuanzhuan.com/api/click',
        params: {
          metric: obj.metric,
          adTicket: obj.adTicket
        },
        timeout: 1000
      }).then(function () {
        lego.send({
          pagetype: 'AD_YOUPINLIST',
          actiontype: 'AD_CLICK',
          backup: _objectSpread({
            status: 1
          }, legoParams)
        });
        setTimeout(function () {
          cb();
        }, 100);
      }).catch(function (e) {
        if (e.message && ~e.message.indexOf('timeout')) {
          lego.send({
            pagetype: 'AD_YOUPINLIST',
            actiontype: 'AD_CLICK',
            backup: _objectSpread({
              status: 3
            }, legoParams)
          });
          setTimeout(function () {
            cb();
          }, 100);
        } else {
          lego.send({
            pagetype: 'AD_YOUPINLIST',
            actiontype: 'AD_CLICK',
            backup: _objectSpread({
              status: 2
            }, legoParams)
          });
          setTimeout(function () {
            cb();
          }, 100);
        }
      });
    }
  }, {
    key: "chooseAddress",
    value: function chooseAddress() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = obj.url,
        addressId = obj.addressId,
        isCanClose = obj.isCanClose;
      var isCanCloseStr = isCanClose === undefined ? '' : "&isCanClose=".concat(isCanClose);
      var href = "".concat(getDomain(), "/trade/user-address/index.html?url=").concat(encodeURIComponent(url || window.location.href), "&addressId=").concat(addressId || 0).concat(isCanCloseStr, "#/myAddress");
      window.location.href = href;
    }

    // 推荐使用交易团队提供的trade-core库来实现跳转下单等功能
  }, {
    key: "skipToOrder",
    value: function skipToOrder(obj) {
      var orderUrl = obj.orderUrl,
        metric = obj.metric,
        infoId = obj.infoId;
      if (orderUrl) {
        window.location.href = urlFormatter(orderUrl);
        return;
      }
      window.location.href = "".concat(getDomain(), "/trade/create-order/index.html?metric=").concat(metric, "&infoId=").concat(infoId, "#/home");
    }

    // 推荐使用交易团队提供的trade-core库来实现跳转订单详情等功能
  }, {
    key: "enterOrderDetail",
    value: function enterOrderDetail(obj) {
      var orderId = obj.orderId,
        metric = obj.metric;
      window.location.href = "".concat(getDomain(), "/trade/order-detail/home.html?orderId=").concat(orderId, "&metric=").concat(metric);
    }
  }, {
    key: "enterChat",
    value: function enterChat(obj) {
      var infoId = obj.infoId,
        uid = obj.uid,
        rest = _objectWithoutProperties(obj, _excluded);
      var restList = [];
      Object.keys(rest).forEach(function (key) {
        restList.push(encodeURIComponent("".concat(key, "=").concat(rest[key])));
      });
      var restParam = '';
      if (restList.length > 0) {
        restParam = "&".concat(restList.join('&'));
      }
      window.location.href = "//chat.zhuanzhuan.com/m/?infoId=".concat(infoId, "&userId=").concat(uid).concat(restParam);
    }
  }, {
    key: "registerPageCallback",
    value: function registerPageCallback(callback) {
      if (_typeof(callback) === 'object') {
        callback = callback.callback;
      }
      document.addEventListener(getVisibilityChangeSupported(), function () {
        if (document.visibilityState === 'visible') {
          callback && callback({
            code: '0',
            msg: '页面显示',
            pageState: '1',
            result: ''
          });
        }
      });
    }
  }, {
    key: "onShow",
    value: function onShow() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (_typeof(callback) === 'object') {
        callback = callback.callback;
      }
      document.addEventListener('pageshow', function () {
        callback && callback({
          code: '0',
          msg: '页面显示',
          isFirstShow: true
        });
      });
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'visible') {
          callback && callback({
            code: '0',
            msg: '页面显示',
            isFirstShow: false
          });
        }
      }, true);
    }
  }, {
    key: "onHide",
    value: function onHide() {
      var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      if (_typeof(callback) === 'object') {
        callback = callback.callback;
      }
      var isIOS = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      if (!isIOS) {
        document.addEventListener('pagehide', function () {
          callback && callback({
            code: '0',
            msg: '页面隐藏',
            result: ''
          });
        }, true);
      } else {
        document.addEventListener('beforeunload', function () {
          callback && callback({
            code: '0',
            msg: '页面隐藏',
            result: ''
          });
        }, true);
      }
      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') {
          callback && callback({
            code: '0',
            msg: '页面隐藏',
            result: ''
          });
        }
      }, true);
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate(callback) {
      var _window$nativeAdapter2;
      var cbName = "getCoordinate".concat(guid());
      window[cbName] = function (res) {
        if (res.status === 0) {
          var position = res.result.location;
          callback({
            code: '0',
            lon: String(position.lng),
            lat: String(position.lat),
            result: res.result
          });
        } else {
          callback({
            code: '-1'
          });
        }
      };
      var KEY = ((_window$nativeAdapter2 = window.nativeAdapterConfig) === null || _window$nativeAdapter2 === void 0 ? void 0 : _window$nativeAdapter2.qqMapKey) || QQ_MAP_KEY;
      loadJS("https://apis.map.qq.com/ws/location/v1/ip?key=".concat(KEY, "&output=jsonp&callback=").concat(cbName), function () {
        return window[cbName] = void 0;
      });

      // 该API腾讯地图已经废弃，有bug
      // loadJS('https://3gimg.qq.com/lightmap/components/geolocation/geolocation.min.js', () => {
      //   const geolocation = new qq.maps.Geolocation(QQ_MAP_KEY, "zzapp");
      //   geolocation.getLocation((position) => {
      //     callback({
      //       code: "0",
      //       lon: position.lng,
      //       lat: position.lat
      //     });
      //   }, () => {
      //     callback({ code: '-1' });
      //   })
      // });
    }
  }, {
    key: "replaceDomain",
    value: function replaceDomain(originUrl) {
      return domainReplacement(originUrl);
    }
  }, {
    key: "goBack",
    value: function goBack(callback) {
      // 返回上一个页面，如果当前页面处于历史页面栈顶，则执行关闭页面方法
      // 通过referrer是否为空来判断页面是否处于历史堆栈顶层
      if (document.referrer === '') {
        this.close();
      } else {
        history.go(-1);
      }
      // 提供回调函数，用于回退失败时候执行部分逻辑
      callback && callback();
    }

    /**
     *  发送验证码
     *
     * @param {tel} tel 手机号 某些动作不需要手机号，登录态取UID 获取手机号
     * @param {channel} channel 'sms'（发送验证码过风控，有可能拉起图形验证码）'smssa'(直接发送)
     * @param {action} action   动作 200: 注册 201:登录 206:身份核验 205:换绑手机号 忘记密码：1003  207 5-M页验证码登录
     * @param {type} type  注册图形验证码的信息 2:uid获取图形验证码 3:token获取图形验证码 4:mobile获取图形验证码
     * @param {uuid} uuid	用户唯一标识, 根据type决定类型
     * @returns { code: 0, data: {} }   0 或者 -1  data 是返回的数据  -1 是提示信息
     * @memberof BaseAdapter
     */
  }, {
    key: "sendValidationCode",
    value: (function () {
      var _sendValidationCode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(params, cb) {
        var _this5 = this;
        var res, _res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(params.channel === 'smssa')) {
                _context5.next = 5;
                break;
              }
              _context5.next = 3;
              return this.sendCode(params);
            case 3:
              res = _context5.sent;
              cb(res);
            case 5:
              if (!(params.channel === 'sms')) {
                _context5.next = 10;
                break;
              }
              _context5.next = 8;
              return this.sendCode(params);
            case 8:
              _res = _context5.sent;
              // 如果需要拉起
              if (_res && _res.data && _res.data.alertCode) {
                this.registerSlider(params, /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(res58) {
                    var resAuth;
                    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) switch (_context4.prev = _context4.next) {
                        case 0:
                          if (!(res58.code == 0)) {
                            _context4.next = 7;
                            break;
                          }
                          _context4.next = 3;
                          return _this5.sendCode(_objectSpread(_objectSpread({}, params), {}, {
                            channel: 'smsslg',
                            codeid: res58.data.sessionId,
                            codetoken: res58.data.successToken
                          }));
                        case 3:
                          resAuth = _context4.sent;
                          cb(resAuth);
                          _context4.next = 8;
                          break;
                        case 7:
                          cb(res58);
                        case 8:
                        case "end":
                          return _context4.stop();
                      }
                    }, _callee4);
                  }));
                  return function (_x6) {
                    return _ref4.apply(this, arguments);
                  };
                }());
              } else {
                cb(_res);
              }
            case 10:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function sendValidationCode(_x4, _x5) {
        return _sendValidationCode.apply(this, arguments);
      }
      return sendValidationCode;
    }() // 发送验证码
    )
  }, {
    key: "sendCode",
    value: function sendCode(params) {
      return new Promise(function (resolve) {
        request({
          url: "https://app.zhuanzhuan.com/zz/transfer/getvalidationcode",
          params: params
        }).then(function (res) {
          if (res.respCode == 0) {
            resolve({
              code: 0,
              data: res.respData
            });
          } else {
            resolve({
              code: -1,
              data: res.errMsg
            });
          }
        }).catch(function () {
          resolve({
            code: -1,
            data: '验证码发送失败'
          });
        });
      });
    }
  }, {
    key: "getCookie",
    value: function getCookie(callback) {
      callback && callback({
        code: '0',
        cookie: document.cookie
      });
    }

    // 拉起滑动验证码
  }, {
    key: "registerSlider",
    value: function registerSlider(params, callback) {
      loadJS("https://j1.58cdn.com.cn/resource/xxzl/captcha/js/isd_captcha.js?=".concat(new Date().setHours(0, 0, 0, 0)), function () {
        request({
          url: "https://app.zhuanzhuan.com/zz/transfer/registerslidernew",
          method: 'post',
          params: {
            uuid: params.uuid || getCookie('tk'),
            scenetype: params.scenetype || 77,
            width: params.width || 280,
            type: params.type || 3,
            subOp: params.action
          }
        }).then(function (res) {
          var code = parseInt(res.respCode);
          var data = res.respData;
          if (code === 0) {
            var captcha = window.ISDCaptcha({
              element: 'ISDCaptcha',
              //验证码组件需要绑定的元素ID
              width: data.controlParams.width,
              //图片宽度,需从管理后台配置，调用注册接口是controlParams参数返回
              type: Number(data.level),
              //验证码类型; 调用注册接口时返回的level
              showType: params.showType || 'win',
              //展现形式;win:弹出，trigger:触发,embed:嵌入
              sessionId: data.sessionId,
              // 调用注册接口时返回的sessionid
              targetElm: 'loginBtn',
              // 如果为弹出式时,绑定为触发弹出的按钮ID
              winAutoShow: true,
              //弹出式时添加此属性会自动弹出	，,默认不自动弹出,点targetElm绑定的元素时弹出
              successCallback: function successCallback(value) {
                //验证码验证成功后的回调函数
                callback({
                  code: 0,
                  data: _objectSpread({
                    sessionId: data.sessionId
                  }, value)
                });
              },
              failCallback: function failCallback(data) {
                lego.send({
                  pagetype: 'SENTRY_ADATPER_SENDCODE',
                  actiontype: 'SENTRY_ADATPER_SENDCODE_FAIL',
                  backup: data
                });
                callback({
                  code: -1,
                  data: '身份验证失败'
                });
              },
              errorCallback: function errorCallback(data) {
                lego.send({
                  pagetype: 'SENTRY_ADATPER_SENDCODE',
                  actiontype: 'SENTRY_ADATPER_SENDCODE_ERROR',
                  backup: data
                });
                callback({
                  code: -2,
                  data: data
                });
              },
              closeCallback: function closeCallback(data) {
                callback({
                  code: -3,
                  data: data
                });
              }
            });
            captcha.init(); //初始化组件
          } else {
            callback({
              code: -1,
              data: res.errMsg || res.respMsg || '身份验证失败'
            });
          }
        }).catch(function (err) {
          console.log('58sdk发送错误：', err);
          lego.send({
            pagetype: 'SENTRY_ADATPER_SENDCODE',
            actiontype: 'SENTRY_ADATPER_SENDCODE_SDKERROR',
            backup: err
          });
          // callback({ code: -1, data: "身份验证失败" });
        });
      });
    }
  }, {
    key: "setStoreItem",
    value: function setStoreItem(group, name, value, expire, callback) {
      try {
        // If the value is an object, stringify it.
        if (_typeof(value) === 'object') {
          value = JSON.stringify(value);
        }
        // If there is an expiration date, calculate it.
        if (typeof expire === 'number') {
          expire = Date.now() + expire * 1000 * 60 * 60 * 24;
        }
        // Save the value in local storage, with the expiration date if there is one.
        window.localStorage.setItem("".concat(group, "_").concat(name), JSON.stringify({
          value: value,
          expire: expire
        }));
        callback && callback(true);
      } catch (error) {
        console.log(error);
        callback && callback(false);
      }
    }
  }, {
    key: "getStoreItem",
    value: function getStoreItem(group, name, callback) {
      var key = "".concat(group, "_").concat(name);
      // Get the value from local storage.
      var str = window.localStorage.getItem(key);
      // If there is no value, return null.
      if (!str) {
        callback && callback(null);
        return;
      }
      try {
        var res = JSON.parse(str);
        var _value = res.value,
          _expire = res.expire;
        if (_expire && _expire < Date.now()) {
          this.removeStoreItem(group, name, function () {
            callback && callback(null);
          });
        } else {
          callback && callback(_value);
        }
      } catch (e) {
        callback && callback(null);
      }
    }
  }, {
    key: "removeStoreItem",
    value: function removeStoreItem(group, name, callback) {
      window.localStorage.removeItem("".concat(group, "_").concat(name));
      callback && callback(null);
    }
  }, {
    key: "copyTextToClipBoard",
    value: function copyTextToClipBoard(clipText, callback) {
      var input = document.createElement('input');
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('value', clipText);
      document.body.appendChild(input);
      input.select();
      input.setSelectionRange(0, 9999);
      if (document.execCommand('copy')) {
        document.execCommand('copy');
        callback && callback({
          code: '0',
          msg: '复制成功'
        });
      } else {
        callback && callback({
          code: '-1',
          msg: '复制失败'
        });
      }
      document.body.removeChild(input);
    }
  }]);
  return BaseAdapter;
}(WaitJsLoaded), _defineProperty(_class2, "pluginName", 'BaseAdapter'), _defineProperty(_class2, "platform", [
// 招商银行
{
  rule: /cmblife/i,
  name: 'cmblife'
},
// 腾讯电脑管家
{
  rule: function rule() {
    return /wesecure/i.test(navigator.userAgent) || /theme=qqmgr/i.test(location.href);
  },
  name: 'qqmgr'
}]), _class2), (_applyDecoratedDescriptor(_class.prototype, "login", [beforeLogin], Object.getOwnPropertyDescriptor(_class.prototype, "login"), _class.prototype)), _class);
export { BaseAdapter as default }; // declare module '../../core' {
//   interface ApiInterface extends PluginAPI {}
// }